export default __webpack_public_path__ + "static/media/mac.cfc2a623.svg";